import { HighPrecisionDecimal } from '@dealstack/shared/lib/format/currency/highPrecisionDecimal';
import {
	BreakpointSummaryPayload,
	SecurityValueOverrideComponent,
	SecurityValueOverrideScope,
} from '@dealstack/shared/lib/generated';
import { SecurityComponentMapValue } from './types';

const ComponentToScopeMap: Record<SecurityValueOverrideComponent, SecurityValueOverrideScope> = {
	[SecurityValueOverrideComponent.COMPONENT_INTEREST]:
		SecurityValueOverrideScope.COMPONENT_INTEREST,
	[SecurityValueOverrideComponent.COMPONENT_PRINCIPAL]:
		SecurityValueOverrideScope.COMPONENT_PRINCIPAL,
	// No dedicated LP override scope; overriding an LP position acts on the whole security.
	[SecurityValueOverrideComponent.COMPONENT_LIQUIDATION_PREFERENCE]:
		SecurityValueOverrideScope.WHOLE_SECURITY,
	[SecurityValueOverrideComponent.COMPONENT_CATCH_UP]:
		SecurityValueOverrideScope.COMPONENT_CATCH_UP,
	[SecurityValueOverrideComponent.COMPONENT_TRACKING]:
		SecurityValueOverrideScope.COMPONENT_TRACKING,
	[SecurityValueOverrideComponent.WHOLE_SECURITY]: SecurityValueOverrideScope.WHOLE_SECURITY,
	[SecurityValueOverrideComponent.COMPONENT_RESIDUE]: SecurityValueOverrideScope.WHOLE_SECURITY,
} as const;

export function buildSecurityComponentMap(
	breakpointSummaryData: BreakpointSummaryPayload | undefined
): Map<string, SecurityComponentMapValue> {
	const map = new Map<string, SecurityComponentMapValue>();
	if (!breakpointSummaryData) {
		return map;
	}

	breakpointSummaryData.tiers.forEach((tier) => {
		tier.securities.forEach((security) => {
			if (security.component === SecurityValueOverrideComponent.COMPONENT_RESIDUE) {
				return;
			}
			map.set(`${security.securityId}-${security.component}-${security.trancheKey}`, {
				securityId: security.securityId,
				name: security.securityName,
				tier: tier.seniorityIndex,
				tierParticipatingValue: new HighPrecisionDecimal(security.totalProceeds),
				valuePerSecurity: new HighPrecisionDecimal(security.totalProceeds).div(
					security.totalUnits
				),
				trancheKey: security.trancheKey,
				override: security.override,
				overrideScope: ComponentToScopeMap[security.component],
				note: security.override?.note ?? '',
			});
		});
	});
	return map;
}
